import { useState, useEffect} from "react";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';


interface BlankPageProps {
    file: string;
  }
  
  // 2. 使用对象解构的方式接收 Props
  export default function BlankPage({ file }: BlankPageProps) {
  const [mdContent, setMdContent] = useState("");
  // 当步骤或 Slide 变化时，加载文字内容
  useEffect(() => {
    const fetchMd = async () => {
      setMdContent(""); // 清空旧内容防止闪烁
      try {
        const response = await fetch(`/policy/${file}.md`);
        if (response.ok) {
          const text = await response.text();
          setMdContent(text);
        }
      } catch (err) {
        setMdContent("");
      }
    };
    fetchMd();
  }, [file]);


  return (
    <section id="blankpage" className="section" style={{ paddingTop: '2rem', paddingBottom: '4rem' }}>
        <div
          style={{
            maxWidth: 1000,
            margin: "0rem auto 0",
            padding: "0px",
            borderRadius: 16,
            border: "1px solid #eee",
            background: "#fff",
          }}
        >
          <div
          >
            {/* TEXT SIDE */}
            <div
              style={{
                // 动态高度与阴影切换
                height: 'auto',
                boxShadow: '0 12px 30px rgba(0,0,0,0.1)',
                // 丝滑动画
                transition: "height 0.35s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.3s ease",

                overflow: "hidden",
                position: "relative",
                background: "#fff",
                zIndex: 10,
              }}
            >
              <div className="markdown-body" style={{ padding: "10px",fontSize: 15, lineHeight: 1.8, color: "#444", paddingTop:"0px", marginTop:"0px" }}>
                <ReactMarkdown 
                  remarkPlugins={[remarkGfm]}
                  components={{
                      // 拦截 table 标签
                      table: ({node, ...props}) => (
                        <div style={{ overflowX: 'auto' }}> {/* 移动端自适应滚动 */}
                          <table 
                            style={{ 
                              width: '100%',     // 撑满父容器
                              minWidth: '600px', // 确保在窄屏下不会挤成一团
                              borderCollapse: 'collapse',
                              margin: '1rem 0'
                            }} 
                            {...props} 
                          />
                        </div>
                      ),
                      // 可选：让表头文字更舒展
                      th: ({node, ...props}) => (
                        <th style={{ border: '1px solid #dfe2e5', padding: '12px 15px' }} {...props} />
                      ),
                      td: ({node, ...props}) => (
                        <td style={{ border: '1px solid #dfe2e5', padding: '12px 15px', textAlign: 'center' }} {...props} />
                      ),
                    }}
                >
                  {mdContent}
                </ReactMarkdown>
              </div>
            </div>
          </div>
        </div>
    </section>
  );
}
